import useBaseMessangeSuccess from './useBaseMessageSuccess';
import useSnackbar from './useSnackbar';

function useSnackbarSuccess() {
  return useBaseMessangeSuccess({ hook: useSnackbar });
}

export default useSnackbarSuccess;
